import { getUserAgent } from './ssrCompatible'
import { isIphone } from './platform'

// 是否在pubgm 游戏的app中
export function isInPubgmGame() {
  if (!process.client) {
    return false
  }

  if (window.IMSDK) {
    return true
  }

  if (window.__pubgm_iOSBridge) {
    return true
  }
  return false
}

// iOS JS Bridge 初始化代码的定义
// function setupWebViewJavascriptBridge(callback) {
//   if (!process.client) {
//     return
//   }
//   if (window.WebViewJavascriptBridge) {
//     return callback(WebViewJavascriptBridge)
//   }
//   if (window.WVJBCallbacks) {
//     return window.WVJBCallbacks.push(callback)
//   }
//   window.WVJBCallbacks = [callback]
//   var WVJBIframe = document.createElement('iframe')
//   WVJBIframe.style.display = 'none'
//   WVJBIframe.src = 'https://__bridge_loaded__'
//   document.documentElement.appendChild(WVJBIframe)
//   setTimeout(function () {
//     document.documentElement.removeChild(WVJBIframe)
//   }, 0)
// }
// 初始化ios bridge方法
// export function initPubgmIOSBridge() {
//   if (!process.client) {
//     return
//   }
//   let iOSBridge = null // 全局 iOS Bridge

//   // iOS 初始化及注册 Native 调用 JS 回调代码
//   if (isIphone() && !window.MSStream) {
//     setupWebViewJavascriptBridge(function (bridge) {
//       //注册 Native 调用 JS 的回调函数
//       bridge.registerHandler('IMSDKJSHandler', function () {
//         //在这里处理 Native 调用 JS，携带参数为 parametersJSON，responseCallback 忽略即可
//         // nativeCall(parametersJSON)
//       })
//       iOSBridge = bridge
//       window.__pubgm_iOSBridge = iOSBridge
//     })
//   }
// }

// 在Safari中打开url
export function jsCallNativeOpenUrlInSafari() {
  if (!process.client) {
    return
  }
  if (isIphone() && !window.MSStream) {
    //iOS 平台 JS 调用 Native
    if (window.__pubgm_iOSBridge) {
      window.__pubgm_iOSBridge.callHandler(
        'openURLInSafiri',
        window.location.href,
        function () {
          // 调用 Native 回调，一般可以忽略
          // console.log(response)
        }
      )
    } else {
      window.console.log('no IMSDK js support')
    }
  }
}

// 向 Native 层发送消息 - 关闭 toolbar
export function jsCallNativeHideToolbar(hide) {
  if (!process.client) {
    return false
  }
  const userAgent = getUserAgent()
  if (/android/i.test(userAgent)) {
    //Android 平台 JS 调用 Native
    if (window.IMSDK) {
      let arg = '{"hideToolBar": ' + hide + '}'
      IMSDK.jsCallNative(arg)
    } else {
      window.console.log('no IMSDK js support')
    }
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.console.log('call iOS native')
    //iOS 平台 JS 调用 Native
    if (window.__pubgm_iOSBridge) {
      window.__pubgm_iOSBridge.callHandler(
        'hideToolBar',
        hide ? 1 : 0,
        function (response) {
          // 调用 Native 回调，一般可以忽略
          window.console.log(response)
        }
      )
    } else {
      window.console.log('no IMSDK js support')
    }
  } else {
    window.console.log('no support')
  }
}
